export const   regionsFetching= 'FETCHING_REGIONS'
export const   regionsFetched= 'FETCHED_REGIONS'
export const   regionsError= 'ERROR_REGIONS'
